import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "clinic-os-access-token";

export const accessToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const accessClient = axios.create({ baseURL: API, withCredentials: true });

accessClient.interceptors.request.use((cfg) => {
  const t = accessToken.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const accessApi = {
  login: (email, password) => accessClient.post("/admin/login", { email, password }),
  logout: () => accessClient.post("/admin/logout"),
  me: () => accessClient.get("/admin/me"),
  // submissions (raw log, every form)
  submissions: (params) => accessClient.get("/admin/submissions", { params }),
  submissionCounts: () => accessClient.get("/admin/submissions/counts"),
  updateSubmission: (id, body) => accessClient.patch(`/admin/submissions/${id}`, body),
  deleteSubmission: (id) => accessClient.delete(`/admin/submissions/${id}`),
  // leads (sales pipeline subset)
  leads: (params) => accessClient.get("/admin/leads", { params }),
  addActivity: (id, body) => accessClient.post(`/admin/submissions/${id}/activity`, body),
  deleteActivity: (id, aid) => accessClient.delete(`/admin/submissions/${id}/activity/${aid}`),
  // pages SEO
  pages: () => accessClient.get("/admin/pages"),
  savePage: (body) => accessClient.put("/admin/pages", body),
  resetPage: (path) => accessClient.delete(`/admin/pages${path}`),
  // analytics
  analytics: (days = 30) => accessClient.get("/admin/analytics/overview", { params: { days } }),
  liveVisitors: () => accessClient.get("/admin/analytics/live"),
  journey: (sessionId) => accessClient.get(`/admin/analytics/journey/${sessionId}`),
  // users
  users: () => accessClient.get("/admin/users"),
  createUser: (body) => accessClient.post("/admin/users", body),
  updateUser: (id, body) => accessClient.patch(`/admin/users/${id}`, body),
  deleteUser: (id) => accessClient.delete(`/admin/users/${id}`),
  // settings
  settings: () => accessClient.get("/admin/settings"),
  saveSettings: (body) => accessClient.put("/admin/settings", body),
  testSmtp: (to) => accessClient.post("/admin/settings/test-smtp", { to }),
  testWebhook: (url) => accessClient.post("/admin/settings/test-webhook", { url }),
};
